module.exports = __webpack_public_path__ + "static/media/kof_video.69a1cff.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/KOF14/top/kof_video.mp4
// module id = dy9w
// module chunks = 0